import React from "react";
import { Position } from "reactflow";
import { Tooltip } from "@mui/material";
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite";
import SettingsIcon from "@mui/icons-material/Settings";
import { HandleDot } from "../handle";
import { useTheme } from "../../../contexts/ThemeContext";

export const StartNode = (props) => {
  const { data, selected, onTrigger, onAdd, ...rest } = props;
  const { darkMode } = useTheme();

  return (
    <div
      className={`w-48 shadow-lg rounded-xl overflow-hidden transition-all duration-200 ${
        darkMode ? "bg-[#18181b] border border-zinc-700" : "bg-white border border-slate-200"
      } ${
        selected ? "ring-2 ring-blue-500 shadow-blue-500/20" : "hover:border-blue-400"
      }`}
    >
      <div className="flex items-center justify-between px-3 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
        <div className="flex items-center gap-1.5">
          <PlayCircleFilledWhiteIcon style={{ fontSize: 16 }} />
          <span className="text-xs font-semibold tracking-wide uppercase">Journey Trigger</span>
        </div>
        {onTrigger && (
          <Tooltip title="Configure Triggers">
            <SettingsIcon
              style={{ fontSize: 14, cursor: "pointer" }}
              onClick={() => onTrigger(props)}
            />
          </Tooltip>
        )}
      </div>

      <div className="p-3">
        <div className={`text-xs font-medium ${darkMode ? "text-zinc-200" : "text-slate-800"}`}>
          {data?.label || "Trigger on Enrollment"}
        </div>
        <div className={`text-[11px] mt-1 ${darkMode ? "text-zinc-400" : "text-slate-500"}`}>
          {data?.triggerSummary ||
            (data?.triggerCount
              ? `${data.triggerCount} active trigger rule(s)`
              : "No triggers enabled")}
        </div>
      </div>

      <HandleDot
        addVisible={true}
        id="next"
        type="source"
        position={Position.Right}
        onAdd={(v) => onAdd(v, rest)}
      />
    </div>
  );
};

